import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

export interface Config {
  apiGatewayEndpoint: string;
  clientSecret: string;
  clientId: string;
  clientEnvironment?: string;
  features?: {
    [name: string]: string;
  };
  sentryEndpoint?: string;
  gtmAccountId?: string;
}

export interface CardBrandProperties {
  brandName: string;
  myAccountLink: string;
  termsAndConditionsLink: string;
  phone1: string;
  phone2: string;
  cardProgrammes?: string[];
}

export interface BrandPropertiesResponse {
  brand: string;
  properties: {
    'myaccount.url': string;
    'contact.phone1': string;
    'contact.phone2': string;
    'initial.page.mcard.name': string;
    'product_website.terms_and_conditions.url': string;
  }[];
}

@Injectable()
export class AppConfigService {
  private config: Config;

  constructor(private httpClient: HttpClient) {}

  get endPoint(): string {
    return this.getConfig().apiGatewayEndpoint + '/api/rest/v1';
  }

  private readonly apiRoutes = {
    cardBrandProperties: (): string => `${this.endPoint}/card_brand/properties`
  };

  getConfig() {
    return this.config;
  }

  getCardBrandProperties(cardBrand: string): Observable<CardBrandProperties> {
    if (environment.useMock) {
      return of({
        brand: 'Q2',
        properties: [
          {
            'myaccount.url':
              'https://www.flexicards.co.nz/qcard/qcard/logon.jsp',
            'initial.page.mcard.name': 'Q Card',
            'contact.phone1': '0800 117 000',
            'product_website.terms_and_conditions.url':
              'https://www.qcard.co.nz/things-to-know/terms-conditions/',
            'contact.phone2': '+ 64 9 525 8554'
          }
        ]
      }).pipe(map(p => this.mapBrandPropertiesResponse(p)));
    }

    let httpParams = new HttpParams();
    httpParams = httpParams.append('brand', cardBrand.toString());
    return this.httpClient
      .get<BrandPropertiesResponse>(this.apiRoutes.cardBrandProperties(), {
        params: httpParams
      })
      .pipe(map(p => this.mapBrandPropertiesResponse(p)));
    // return brandProperties;
  }

  loadConfig(): Promise<any> {
    if (environment.useMock) {
      return Promise.resolve().then(() => {
        this.config = this.getMockConfig();
      });
    }
    return this.httpClient
      .get<Config>(environment.production ? environment.configEndPoint : '/config-dev.json')
      .toPromise()
      .then(data => {
        this.config = data;
      });
  }
  private getMockConfig(): Config {
    const mockConfig: Config = {
      apiGatewayEndpoint: '',
      clientId: '',
      clientSecret: ''
    };
    return mockConfig;
  }
  private mapBrandPropertiesResponse(
    res: BrandPropertiesResponse
  ): CardBrandProperties {
    return {
      myAccountLink: res.properties[0]['myaccount.url'],
      brandName: res.properties[0]['initial.page.mcard.name'],
      termsAndConditionsLink:
        res.properties[0]['product_website.terms_and_conditions.url'],
      phone1: res.properties[0]['contact.phone1'],
      phone2: res.properties[0]['contact.phone2']
    };
  }
}
